import { staticImageUrl } from '../../util/images';

const TWEET_IMAGES = [
  'tweets/wren-tweet-pvloemans.png',
  'tweets/wren-tweet-adrianoflynn.png',
  'tweets/wren-tweet-dyani.png',
  'tweets/wren-tweet-paulg.png',
];

const tweetImage = {
  width: '100%',
  margin: '0 auto',
  display: 'block',
  maxWidth: 400,
  marginBottom: 12,
};

// Vertical stack of individual tweet screenshots, used in place of the
// composite mobile-tweets-fade-out.png collage on mobile landing sections.
export default function MobileTweetStack() {
  return (
    <>
      {TWEET_IMAGES.map((image) => (
        <img
          key={image}
          loading="lazy"
          src={staticImageUrl(image, { w: 800 })}
          css={tweetImage}
        />
      ))}
    </>
  );
}
